export const JOBARK_PHONE_DISPLAY = "01753 316261";
export const JOBARK_PHONE_TEL = "+441753316261";

/** Legacy subject value still present on older tickets */
export const CONTACT_SUBJECT_LEGACY_GENERAL = "generalInquiry";

export const CONTACT_SUBJECT = {
  GENERAL_ENQUIRY: "generalEnquiry",
  EXISTING_BOOKING: "existingBooking",
  NEW_STAFFING_REQUIREMENT: "newStaffingRequirement",
  INVOICE_PAYMENT: "invoicePayment",
  COMPLAINT: "complaint",
  FEEDBACK: "feedback",
  TECHNICAL_SUPPORT: "technicalSupport",
  OTHER: "other",
  EXISTING_ASSIGNMENT: "existingAssignment",
  TIMESHEET_QUERY: "timesheetQuery",
  PAY_QUERY: "payQuery",
  COMPLIANCE_DOCUMENTS: "complianceDocuments",
};

export const CLIENT_CONTACT_DEFAULT_SUBJECT =
  CONTACT_SUBJECT.NEW_STAFFING_REQUIREMENT;

export const WORKER_CONTACT_DEFAULT_SUBJECT =
  CONTACT_SUBJECT.GENERAL_ENQUIRY;

export const CLIENT_CONTACT_SUBJECT_OPTIONS = [
  {
    value: CONTACT_SUBJECT.GENERAL_ENQUIRY,
    labelKey: "contactUsSubjectGeneralEnquiry",
    defaultLabel: "General Enquiry",
  },
  {
    value: CONTACT_SUBJECT.EXISTING_BOOKING,
    labelKey: "contactUsSubjectExistingBooking",
    defaultLabel: "Existing Booking",
  },
  {
    value: CONTACT_SUBJECT.NEW_STAFFING_REQUIREMENT,
    labelKey: "contactUsSubjectNewStaffingRequirement",
    defaultLabel: "New Staffing Requirement",
  },
  {
    value: CONTACT_SUBJECT.INVOICE_PAYMENT,
    labelKey: "contactUsSubjectInvoicePayment",
    defaultLabel: "Invoice / Payment",
  },
  {
    value: CONTACT_SUBJECT.COMPLAINT,
    labelKey: "contactUsSubjectComplaint",
    defaultLabel: "Complaint",
  },
  {
    value: CONTACT_SUBJECT.FEEDBACK,
    labelKey: "contactUsSubjectFeedback",
    defaultLabel: "Feedback",
  },
  {
    value: CONTACT_SUBJECT.TECHNICAL_SUPPORT,
    labelKey: "contactUsSubjectTechnical",
    defaultLabel: "Technical Support",
  },
  {
    value: CONTACT_SUBJECT.OTHER,
    labelKey: "contactUsSubjectOther",
    defaultLabel: "Other",
  },
];

export const WORKER_CONTACT_SUBJECT_OPTIONS = [
  {
    value: CONTACT_SUBJECT.GENERAL_ENQUIRY,
    labelKey: "contactUsSubjectGeneralEnquiry",
    defaultLabel: "General Enquiry",
  },
  {
    value: CONTACT_SUBJECT.EXISTING_ASSIGNMENT,
    labelKey: "contactUsSubjectExistingAssignment",
    defaultLabel: "Existing Assignment",
  },
  {
    value: CONTACT_SUBJECT.TIMESHEET_QUERY,
    labelKey: "contactUsSubjectTimesheetQuery",
    defaultLabel: "Timesheet Query",
  },
  {
    value: CONTACT_SUBJECT.PAY_QUERY,
    labelKey: "contactUsSubjectPayQuery",
    defaultLabel: "Pay Query",
  },
  {
    value: CONTACT_SUBJECT.COMPLIANCE_DOCUMENTS,
    labelKey: "contactUsSubjectComplianceDocuments",
    defaultLabel: "Compliance / Documents",
  },
  {
    value: CONTACT_SUBJECT.TECHNICAL_SUPPORT,
    labelKey: "contactUsSubjectTechnical",
    defaultLabel: "Technical Support",
  },
  {
    value: CONTACT_SUBJECT.COMPLAINT,
    labelKey: "contactUsSubjectComplaint",
    defaultLabel: "Complaint",
  },
  {
    value: CONTACT_SUBJECT.FEEDBACK,
    labelKey: "contactUsSubjectFeedback",
    defaultLabel: "Feedback",
  },
  {
    value: CONTACT_SUBJECT.OTHER,
    labelKey: "contactUsSubjectOther",
    defaultLabel: "Other",
  },
];

/** Union of client + worker subjects for admin filters (plus legacy) */
export const ADMIN_CONTACT_SUBJECT_FILTER_OPTIONS = [
  {
    value: CONTACT_SUBJECT.GENERAL_ENQUIRY,
    label: "General Enquiry",
  },
  {
    value: CONTACT_SUBJECT_LEGACY_GENERAL,
    label: "General Inquiry (legacy)",
  },
  {
    value: CONTACT_SUBJECT.EXISTING_BOOKING,
    label: "Existing Booking",
  },
  {
    value: CONTACT_SUBJECT.NEW_STAFFING_REQUIREMENT,
    label: "New Staffing Requirement",
  },
  {
    value: CONTACT_SUBJECT.INVOICE_PAYMENT,
    label: "Invoice / Payment",
  },
  {
    value: CONTACT_SUBJECT.EXISTING_ASSIGNMENT,
    label: "Existing Assignment",
  },
  {
    value: CONTACT_SUBJECT.TIMESHEET_QUERY,
    label: "Timesheet Query",
  },
  {
    value: CONTACT_SUBJECT.PAY_QUERY,
    label: "Pay Query",
  },
  {
    value: CONTACT_SUBJECT.COMPLIANCE_DOCUMENTS,
    label: "Compliance / Documents",
  },
  {
    value: CONTACT_SUBJECT.COMPLAINT,
    label: "Complaint",
  },
  {
    value: CONTACT_SUBJECT.FEEDBACK,
    label: "Feedback",
  },
  {
    value: CONTACT_SUBJECT.TECHNICAL_SUPPORT,
    label: "Technical Support",
  },
  {
    value: CONTACT_SUBJECT.OTHER,
    label: "Other",
  },
];

export const CLIENT_BOOKING_REFERENCE_SUBJECTS = new Set([
  CONTACT_SUBJECT.EXISTING_BOOKING,
]);

export const CLIENT_STAFFING_GUIDANCE_SUBJECTS = new Set([
  CONTACT_SUBJECT.NEW_STAFFING_REQUIREMENT,
]);

export const WORKER_ASSIGNMENT_REFERENCE_SUBJECTS = new Set([
  CONTACT_SUBJECT.EXISTING_ASSIGNMENT,
  CONTACT_SUBJECT.TIMESHEET_QUERY,
  CONTACT_SUBJECT.PAY_QUERY,
]);

/**
 * @param {"client"|"worker"|string} role
 * @param {string} subject
 * @returns {"bookingReference"|"staffingGuidance"|"assignmentReference"|null}
 */
export function getContactSubjectPromptType(role, subject) {
  if (role === "client") {
    if (CLIENT_BOOKING_REFERENCE_SUBJECTS.has(subject)) {
      return "bookingReference";
    }
    if (CLIENT_STAFFING_GUIDANCE_SUBJECTS.has(subject)) {
      return "staffingGuidance";
    }
    return null;
  }

  if (role === "worker" && WORKER_ASSIGNMENT_REFERENCE_SUBJECTS.has(subject)) {
    return "assignmentReference";
  }

  return null;
}

/**
 * @param {"client"|"worker"|string} role
 */
export function getContactSubjectOptions(role) {
  return role === "worker"
    ? WORKER_CONTACT_SUBJECT_OPTIONS
    : CLIENT_CONTACT_SUBJECT_OPTIONS;
}

/**
 * @param {"client"|"worker"|string} role
 */
export function getContactDefaultSubject(role) {
  return role === "worker"
    ? WORKER_CONTACT_DEFAULT_SUBJECT
    : CLIENT_CONTACT_DEFAULT_SUBJECT;
}
